import { render, staticRenderFns } from "./labTests.vue?vue&type=template&id=2e571503&"
import script from "./labTests.vue?vue&type=script&lang=js&"
export * from "./labTests.vue?vue&type=script&lang=js&"
import style0 from "./labTests.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports